import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import * as React from "react";
import styled from "styled-components";
import { AvatarCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/AvatarCarousel";
import { BrandTileCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/BrandTileCarousel";
import { DynamicAutoColumnGrid } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/DynamicAutoColumnGrid";
import { DynamicSparseGrid } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/DynamicSparseGrid";
import { FlashSaleCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/FlashSaleCarousel";
import { InsightsCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/InsightsCarousel";
import { MostPopularBrandsCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/MostPopularBrandsCarousel";
import { NoOpLayoutElement } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/NoOpLayoutElement";
import { ProductWithBrandCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/ProductWithBrandCarousel";
import { SampleRequestCarousel } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/SampleRequestCarousel";
import { SearchIconPills } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/SearchIconPills";
import { SearchPills } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/SearchPills";
import { SearchTiles } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/SearchTiles";
import { TallCategoryTiles } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/TallCategoryTiles";
import { VerticalExpandingTiles } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/VerticalExpandingTiles";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { getMilestoneInteractionsByType } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Utils";
import { assignSettingOnEvent } from "@faire/retailer/settings/assignSettingOnEvent";
import { useRecordMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
export var LayoutElementCarouselProps;
(function(LayoutElementCarouselProps) {
    LayoutElementCarouselProps.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(LayoutElementCarouselProps || (LayoutElementCarouselProps = {}));
export var LayoutElementCarousel = function(props) {
    var recordMilestone = useRecordMilestone();
    var layoutElement = React.useContext(Context).layoutElement;
    var onViewRef = useDoActionWhenVisible(function() {
        var _layoutElement_layout_element_data_assign_settings_on_client_view;
        getMilestoneInteractionsByType(layoutElement, "RECORD_UPON_SEEN").forEach(function(milestone) {
            recordMilestone(milestone);
        });
        (_layoutElement_layout_element_data_assign_settings_on_client_view = layoutElement.layout_element_data_assign_settings_on_client_view) === null || _layoutElement_layout_element_data_assign_settings_on_client_view === void 0 ? void 0 : _layoutElement_layout_element_data_assign_settings_on_client_view.forEach(function(setting) {
            return assignSettingOnEvent(setting);
        });
    });
    if (!layoutElement.type) {
        return null;
    }
    var CarouselComponent = carouselComponentMap.get(layoutElement.type);
    if (!CarouselComponent) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CarouselWrapper, {
        ref: onViewRef,
        children: /*#__PURE__*/ _jsx(CarouselComponent, _object_spread({}, props))
    });
};
export var carouselComponentMap = new Map([
    [
        ILayoutElement.Type.AVATAR_CAROUSEL,
        AvatarCarousel
    ],
    [
        ILayoutElement.Type.AVATAR_CAROUSEL_WITH_GRID,
        AvatarCarousel
    ],
    [
        ILayoutElement.Type.BUY_FROM_SAMPLES_CAROUSEL,
        ProductWithBrandCarousel
    ],
    [
        ILayoutElement.Type.DYNAMIC_GRID_OR_CAROUSEL,
        DynamicAutoColumnGrid
    ],
    [
        ILayoutElement.Type.DYNAMIC_SPARSE_GRID,
        DynamicSparseGrid
    ],
    [
        ILayoutElement.Type.HOMEPAGE_SEARCH_QUERIES_BANNER,
        SearchTiles
    ],
    [
        ILayoutElement.Type.LEAN_PRODUCT_WITH_BRAND_TILE_CAROUSEL,
        ProductWithBrandCarousel
    ],
    [
        ILayoutElement.Type.MOST_POPULAR_BRANDS,
        MostPopularBrandsCarousel
    ],
    [
        ILayoutElement.Type.NO_OP_LAYOUT_ELEMENT,
        NoOpLayoutElement
    ],
    [
        ILayoutElement.Type.PRODUCT_TILE_CAROUSEL,
        ProductWithBrandCarousel
    ],
    [
        ILayoutElement.Type.RECENT_SEARCHES_CAROUSEL,
        SearchIconPills
    ],
    [
        ILayoutElement.Type.RETAILER_BRAND_INSIGHTS_CAROUSEL,
        InsightsCarousel
    ],
    [
        ILayoutElement.Type.SAMPLE_REQUEST_CAROUSEL,
        SampleRequestCarousel
    ],
    [
        ILayoutElement.Type.SEARCH_FILTER_PILLS,
        SearchPills
    ],
    [
        ILayoutElement.Type.SMALL_FLASH_SALE_CAROUSEL,
        FlashSaleCarousel
    ],
    [
        ILayoutElement.Type.SMALL_MAKER_TILE_CAROUSEL,
        BrandTileCarousel
    ],
    [
        ILayoutElement.Type.TALL_CATEGORY_TILE,
        TallCategoryTiles
    ],
    [
        ILayoutElement.Type.VERTICALLY_EXPANDABLE_PRODUCT_GRID,
        VerticalExpandingTiles
    ],
    [
        ILayoutElement.Type.WAREHOUSE_SALE_CAROUSEL,
        FlashSaleCarousel
    ]
]);
var CarouselWrapper = styled.div.withConfig({
    componentId: "sc-23951bbc-0"
})([
    "flex:1;min-width:0;&:empty ~ div{display:none;}> span{width:100%;}",
    "{overflow-x:hidden;}"
], responsiveMediaQueries.mobile);
